import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  UtimacoPacketSwitch,
  API_PATH_UTIMACO_PACKET_SWITCH,
} from './utimacoPacketSwitch.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getUtimacoPacketSwitchList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<UtimacoPacketSwitch>> {
  return http.get(`${API_PATH_UTIMACO_PACKET_SWITCH}/${deliveryFunctionId}`);
}

export function getUtimacoPacketSwitch(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<UtimacoPacketSwitch>> {
  return http.get(`${API_PATH_UTIMACO_PACKET_SWITCH}/${deliveryFunctionId}/${id}`);
}

export function createUtimacoPacketSwitch(
  deliveryFunctionId: string,
  body: WithAuditDetails<UtimacoPacketSwitch>,
): AxiosPromise<ServerResponse<UtimacoPacketSwitch>> {
  return http.post(`${API_PATH_UTIMACO_PACKET_SWITCH}/${deliveryFunctionId}`, body);
}

export function updateUtimacoPacketSwitch(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<UtimacoPacketSwitch>,
): AxiosPromise<ServerResponse<UtimacoPacketSwitch>> {
  return http.put(`${API_PATH_UTIMACO_PACKET_SWITCH}/${deliveryFunctionId}/${id}`, body);
}

export function deleteUtimacoPacketSwitch(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<UtimacoPacketSwitch>> {
  return http.delete(`${API_PATH_UTIMACO_PACKET_SWITCH}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
